import AdsEngagePage from "./AdsEngagePage";

const AdsCampaigns = () => <AdsEngagePage />;

export default AdsCampaigns;
